import React, { useEffect, useCallback} from 'react'
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SideStyle from '../style/sideStyle';

import Param from '../store/param';
import Control from '../store/control';
import { toast } from 'react-toastify';


/**
 * A React component that renders a form for aligning a 3D object.
 * @returns {JSX.Element} - The JSX markup for the component.
 */
const FormAlign_0 = () => {
  const style = SideStyle();
  const align        = Param.Get('align');
  const setParam     = Param.Get('setParam');
  const setup         = Param.Get('setup');
  
  const setControl   = Control.Get('setControl');
  const SetCameraFront  = Control.Get('SetCameraFront');
  const currentAngle = Control.Get('currentAngle');
  const prosthetics = Control.Get('prosthetics');

  useEffect(() => {
    // toast.info('Wait for few seconds to initiate the position.' , {autoClose: 3000});
    // setTimeout(() => {
    //   setCenterButton();
    // }, '1000');
    SetCameraFront();
  }, []);
  /**
   * Sets the X angle in counter-clockwise direction by the given angle.
   * @param {number} angle - The angle to rotate in degrees.
   */
  const setXangleCCW = (angle) => {
    setParam(s => {s.align.rotationX = -Number(angle)});
    setControl(s => {s.redrawAngle = [true, false, false]});
  }
  /**
   * Sets the X angle in clockwise direction by the given angle.
   * @param {number} angle - The angle to rotate in degrees.
   */
  const setXangleCW = (angle) => {
    setParam(s => {s.align.rotationX = Number(angle)});
    setControl(s => {s.redrawAngle = [true, false, false]});
  }
  /**
   * Sets the Y angle in counter-clockwise direction by the given angle.
   * @param {number} angle - The angle to rotate in degrees.
   */
  const setYangleCCW = (angle) => {
    if ( setup.side == 1 && prosthetics == 'AK' ) angle *= -1;
    setParam(s => {s.align.rotationY = Number(angle)});
    setControl(s => {s.redrawAngle = [false, true, false]});
  }
  /**
   * Sets the Y angle in clockwise direction by the given angle.
   * @param {number} angle - The angle to rotate in degrees.
   */
  const setYangleCW = (angle) => {
    if ( setup.side == 1 && prosthetics == 'AK' ) angle *= -1;
    setParam(s => {s.align.rotationY = -Number(angle)});
    setControl(s => {s.redrawAngle = [false, true, false]});
  }
  /**
   * Sets the Z angle in counter-clockwise direction by the given angle.
   * @param {number} angle - The angle to rotate in degrees.
   */
  const setZangleCCW = (angle) => {
    if ( setup.side == 1 && prosthetics == 'AK' ) angle *= -1;
    setParam(s => {s.align.rotationZ = Number(angle)});
    setControl(s => {s.redrawAngle = [false, false, true]});
  }
  /**
   * Sets the Z angle in clockwise direction by the given angle.
   * @param {number} angle - The angle to rotate in degrees.
   */
  const setZangleCW = (angle) => {
    if ( setup.side == 1 && prosthetics == 'AK' ) angle *= -1;
    setParam(s => {s.align.rotationZ = -Number(angle)});
    setControl(s => {s.redrawAngle = [false, false, true]});
  }

  const handleValue = (e) => {
    setParam(s => {s.align[e.target.name]=e.target.value});
  };

  const setRotateAxis = useCallback((val) => {
    setParam(s => {s.align.rotateYaxis = val});
  });

  const setAngle = (e) => {
    setParam(s => {s.align[e.currentTarget.name]=e.currentTarget.value});
  }
  
  function setInitialAngle() {
    setControl(s => {s.redrawAngle = true});
  }

  /**
   * Rotates the object in a counter-clockwise direction based on the current angle.
   * @function
   * @name ccw
   * @returns {void}
   */
  const ccw = () => {
    // console.log('rotateYaxis', align.rotateYaxis)
    // console.log('currentAngle', currentAngle)
    switch (currentAngle) {
      case 1: // Front
        (align.rotateYaxis) ? setYangleCCW(align.degree) : setZangleCCW(align.degree);
        break;
      case 2: // Back
        (align.rotateYaxis) ? setYangleCCW(-align.degree) : setZangleCCW(-align.degree);
        break;
      case 3: // Top
        (align.rotateYaxis) ? setZangleCCW(-align.degree) : setYangleCCW(align.degree);
        break;
      case 4: // Bottom
        (align.rotateYaxis) ? setZangleCCW(align.degree) : setYangleCCW(-align.degree);
        break;
      case 5: // Right
        (align.rotateYaxis) ? setYangleCCW(-align.degree) : setXangleCCW(align.degree);
        break;
      case 6: // Left
        (align.rotateYaxis) ? setYangleCCW(align.degree) : setXangleCCW(-align.degree);
        break;
    }
  };
  
  /**
   * Rotate the object clockwise based on the current angle and the axis of rotation.
   * @function
   * @name cw
   * @returns {void}
   */
  const cw = () => {
    switch (currentAngle) {
      case 1: // Front
        (align.rotateYaxis) ? setYangleCW(align.degree) : setZangleCW(align.degree);
        break;
      case 2: // Back
        (align.rotateYaxis) ? setYangleCW(-align.degree) : setZangleCW(-align.degree);
        break;
      case 3: // Top
        (align.rotateYaxis) ? setZangleCW(-align.degree) : setYangleCW(align.degree);
        break;
      case 4: // Bottom
        (align.rotateYaxis) ? setZangleCW(align.degree) : setYangleCW(-align.degree);
        break;
      case 5: // Right
        (align.rotateYaxis) ? setYangleCW(-align.degree) : setXangleCW(align.degree);
        break;
      case 6: // Left
        (align.rotateYaxis) ? setYangleCW(align.degree) : setXangleCW(-align.degree);
        break;
    }
  };

  /**
   * Returns a string representing the CSS classes for a button element based on the value of `align.rotateYaxis`.
   * @param {string} val - The value to compare with `align.rotateYaxis`.
   * @returns {string} - A string representing the CSS classes for a button element.
   */
  function getActive(val){
    return (align.rotateYaxis == val) 
      ? `${style.button} ${style.buttonSelected}`
      : style.button;
  }

  return (
    <div className={style.outside2}>
      {/* <Grid container spacing={1} alignItems='center'>
        <Grid item xs={4}>
          <Button className={style.button} onClick={setCenterButton} >To Center</Button>
        </Grid>
      </Grid> */}

      <Grid container spacing={1} alignItems='center'>
        <Grid item xs={4}>
          <Typography>Rotation Axis</Typography>
        </Grid>
        <Grid item xs={4}>
          <Button name='rotateView' className={getActive(0)} onClick={() => setRotateAxis(0)}>View</Button>
        </Grid>
        <Grid item xs={4}>
          <Button name='rotateView' className={getActive(1)} onClick={() => setRotateAxis(1)}>Y Axis</Button>
        </Grid>
      </Grid>
        
      <Grid container spacing={1} alignItems='center'>
        <Grid item xs={6}>
          <Grid container spacing={1} alignItems='center'>
            <Grid item xs={4}>
              <Typography>Angle</Typography>
            </Grid>
            <Grid item xs={8}>
              <FormControl>
                <Input
                      type='number'
                      name='degree'
                      value={align.degree}
                      onChange={handleValue}
                      endAdornment={<InputAdornment position='end'>deg</InputAdornment>}
                      variant='filled'
                />
              </FormControl>
            </Grid>
          </Grid>
          <Grid container spacing={1} alignItems='center'>
            <Grid item xs={4}>
              <Button name='degree' className={style.button} onClick={setAngle} value='1'>1</Button>
            </Grid>
            <Grid item xs={4}>
              <Button name='degree' className={style.button} onClick={setAngle} value='5'>5</Button>
            </Grid>
            <Grid item xs={4}>
              <Button name='degree' className={style.button} onClick={setAngle} value='90'>90</Button>
            </Grid>
          </Grid>
        </Grid>
            
        <Grid item xs={6}>
          <Grid container spacing={1} alignItems='center'>
            <Grid item xs={6}>
              <Button className={style.button} onClick={ccw} >
                <span>CCW</span> <FontAwesomeIcon icon={['fas', 'undo']} />
              </Button>
            </Grid>
                
            <Grid item xs={6}>
              <Button className={style.button} onClick={cw} >
                <span>CW</span> <FontAwesomeIcon icon={['fas', 'redo']} />
              </Button>
            </Grid>
          </Grid>  
        </Grid>
      </Grid>

    </div>
  );
}
export default FormAlign_0;
